var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.128 10.0247C15.1027 10.0861 15.0661 10.1413 15.0201 10.1873L12.3534 12.854C12.2561 12.9513 12.1281 13.0007 12.0001 13.0007C11.8721 13.0007 11.7441 12.952 11.6467 12.854C11.4514 12.6587 11.4514 12.342 11.6467 12.1466L13.46 10.3333H4.66675C3.28875 10.3333 2.16675 9.212 2.16675 7.83333V4.5C2.16675 4.224 2.39075 4 2.66675 4C2.94275 4 3.16675 4.224 3.16675 4.5V7.83333C3.16675 8.66067 3.84008 9.33333 4.66675 9.33333H13.4594L11.6461 7.52002C11.4507 7.32469 11.4507 7.008 11.6461 6.81266C11.8414 6.61733 12.1581 6.61733 12.3534 6.81266L15.0201 9.47933C15.0661 9.52533 15.1027 9.58059 15.128 9.64193C15.1787 9.76459 15.1787 9.90207 15.128 10.0247Z",
    fill: "#505A72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.ebec60ed.svg";
export { ForwardRef as ReactComponent };